/**
 * 上传管理中心页面
 */
import React from 'react'
import PureList from 'pureComponents/PureList'
import { UPLOADING_LIST } from './constants'
import useUploadingList from './hooks/useUploadingList'

const UploadingList = (props = {}) => {
    const { state, setState, colRender } = useUploadingList(props)
    return (
        <PureList
            {...state}
            {...setState}
            columnsConfig={UPLOADING_LIST || []}
            colRender={colRender}
            showFilter={false}
            showSearch={false}
        />
    )
}

export default UploadingList
